import React from 'react';
import { ArrowRight } from 'lucide-react';
import { SERVICES } from '../mock';

const Services = () => {
  return (
    <section id="services" className="py-20 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#0d3d5e]">
            Our Refrigerated Transport Services
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            From same-day urgent deliveries to scheduled recurring transport,
            we keep your cold chain intact across Perth.
          </p>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <a
              key={s.title}
              href="#services"
              className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow duration-300 border border-slate-100 flex flex-col"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <h3 className="text-lg font-bold text-[#0d3d5e]">{s.title}</h3>
                <p className="mt-2 text-slate-600 text-sm leading-relaxed flex-1">
                  {s.desc}
                </p>
                <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-[#0d3d5e] group-hover:gap-2 transition-all">
                  Learn More <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
